// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"Clearfix_clearfix__UEDOQ"};